const isUndefined = (_) => _ === void 0;

export { isUndefined };
